import { Component, OnInit, HostBinding, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-skeleton-profile',
  templateUrl: 'skeleton-profile.component.html',
})
export class SkeletonProfileComponent implements OnChanges {
  @Input() size: 'small' | 'medium' | 'large' | 'xxl' = 'medium';
  @Input() custom = false;
  @Input() avatarWidth?: string;
  @Input() avatarHeight?: string;
  @Input() titleWidth?: string;
  @Input() titleHeight?: string;
  isCircle = true;
  _avatarWidth = '50px';
  _avatarHeight = '50px';
  _titleWidth = '100%';
  _titleHeight = '20px';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.custom) {
      this._avatarWidth = this.avatarWidth || this._avatarWidth;
      this._avatarHeight = this.avatarHeight || this._avatarHeight;
      this._titleWidth = this.titleWidth || this._titleWidth;
      this._titleHeight = this.titleHeight || this._titleHeight;

      return;
    }

    const { avatarWidth, avatarHeight, titleHeight } = this.getPropertiesBySize();
    this._avatarWidth = avatarWidth;
    this._avatarHeight = avatarHeight;
    this._titleHeight = titleHeight;
  }

  private getPropertiesBySize() {
    const sizes = {
      small: {
        avatarWidth: '25px',
        avatarHeight: '25px',
        titleHeight: '10px',
      },
      medium: {
        avatarWidth: '50px',
        avatarHeight: '50px',
        titleHeight: '20px',
      },
      large: {
        avatarWidth: '75px',
        avatarHeight: '75px',
        titleHeight: '30px',
      },
      xxl: {
        avatarWidth: '100px',
        avatarHeight: '100px',
        titleHeight: '30px',
      },
    };

    return sizes[this.size];
  }
}
